<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <i class="fa-fw fas fa-check-circle text-blue-400"></i>
            </div>
        </template>
        <div class="flex mt-3">
            <div class="w-28 mt-1">Variation Name</div>
            <ui-input name="name" v-model="variationName" class="flex-grow"></ui-input>
        </div>
        <div class="flex mt-1">
            <div class="w-28">Comments</div>
        </div>
        <div>
            <ui-textarea name="comment" v-model="variationComment" class="flex-grow"></ui-textarea>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy"
                               @click="form.submit(); close();"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiTextarea from "../../ui/UiTextarea.vue";

export default {
    components: {UiTextarea, PackageContactSearch, UiDataGrid, UiDataGridItem, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        button: {
            type: String,
            default: 'Accept Proposal',
        },
    },
    data() {
        return {
            variationName: this.name,
            variationComment: '',
            form: new Form({}, async (form) => {
                await this.handle(this.variationName, this.variationComment, this)
            }),
        }
    },
    methods: {},
    mounted() {
    }
}
</script>
